/* G01 Black Friday runtime: phase resolution, phase-scoped content and shared countdowns. */
(function () {
  'use strict';

  var C = window.SNBFCM;
  if (!C || !C.enabled) return;

  var ORDER = ['pre', 'formal', 'cyber', 'extended'];

  function time(value) {
    if (!value) return null;
    var t = Date.parse(value);
    return isNaN(t) ? null : t;
  }

  /* Phase preview (?sn_bfcm_phase=formal) only in the editor or an unpublished theme preview. */
  function previewPhase() {
    var isPreview = C.designMode || (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
    if (!isPreview) return null;
    var match = window.location.search.match(/[?&]sn_bfcm_phase=(pre|formal|cyber|extended|off)\b/);
    return match ? match[1] : null;
  }

  var preview = previewPhase();
  var state = { phase: null };

  function currentPhase(now) {
    if (preview) return preview === 'off' ? '' : preview;
    now = now || Date.now();
    var end = time(C.end);
    if (end !== null && now >= end) return '';
    if (C.mode !== 'auto') return C.manualPhase || '';

    var phase = '';
    for (var i = 0; i < ORDER.length; i++) {
      var start = time(C.starts[ORDER[i]]);
      if (start !== null && now >= start) phase = ORDER[i];
    }
    return phase;
  }

  /* A phase ends when a later phase starts; the last one ends with the campaign. */
  function phaseEnd(phase) {
    var index = ORDER.indexOf(phase);
    if (index < 0) return null;
    for (var i = index + 1; i < ORDER.length; i++) {
      var start = time(C.starts[ORDER[i]]);
      if (start !== null) return start;
    }
    return time(C.end);
  }

  /* Listed drop times win; otherwise drops repeat every N days from the current phase start, capped at the phase end. */
  function nextDrop(now) {
    var best = null;
    (C.drops || []).forEach(function (value) {
      var t = time(value);
      if (t !== null && t > now && (best === null || t < best)) best = t;
    });
    if (best !== null || !(C.dropEvery > 0) || !state.phase) return best;

    var start = time(C.starts[state.phase]);
    var end = phaseEnd(state.phase);
    if (start === null) return null;
    var cycle = C.dropEvery * 86400000;
    var next = now < start ? start : start + (Math.floor((now - start) / cycle) + 1) * cycle;
    return end !== null && next > end ? end : next;
  }

  function resolveTarget(el, now) {
    var target = el.getAttribute('data-sn-bfcm-target') || 'phase-end';
    if (target === 'phase-end') return phaseEnd(state.phase);
    if (target === 'drop') return nextDrop(now);
    if (target === 'flash') return time(C.flashEnd);
    if (target === 'end') return time(C.end);
    return time(target);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function renderCountdown(el, now) {
    var target = resolveTarget(el, now);
    var remaining = target === null ? -1 : target - now;
    var wrap = el.closest('[data-sn-bfcm-countdown-wrap]') || el;

    if (remaining <= 0) {
      if (!el.hasAttribute('data-done')) {
        el.setAttribute('data-done', '');
        if (el.hasAttribute('data-hide-when-done')) wrap.hidden = true;
        el.dispatchEvent(new CustomEvent('sn-bfcm:countdown-done', { bubbles: true }));
      }
      return;
    }

    if (el.hasAttribute('data-done')) {
      el.removeAttribute('data-done');
      wrap.hidden = false;
    }

    var total = Math.floor(remaining / 1000);
    var parts = {
      d: Math.floor(total / 86400),
      h: Math.floor((total % 86400) / 3600),
      m: Math.floor((total % 3600) / 60),
      s: total % 60
    };

    var units = el.querySelectorAll('[data-unit]');
    for (var i = 0; i < units.length; i++) {
      var value = pad(parts[units[i].getAttribute('data-unit')]);
      if (units[i].textContent !== value) units[i].textContent = value;
    }

    var urgentHours = parseFloat(el.getAttribute('data-urgent-hours'));
    if (!isNaN(urgentHours)) el.classList.toggle('is-urgent', remaining <= urgentHours * 3600000);
  }

  function applyPhase(phase) {
    document.documentElement.setAttribute('data-sn-bfcm-phase', phase || 'off');
    var scoped = document.querySelectorAll('[data-sn-bfcm-phases]');
    for (var i = 0; i < scoped.length; i++) {
      var list = scoped[i].getAttribute('data-sn-bfcm-phases').split(',');
      var show = !!phase && (list.indexOf(phase) > -1 || list.indexOf('any') > -1);
      if (list.indexOf('off') > -1 && !phase) show = true;
      scoped[i].hidden = !show;
    }
  }

  function tick() {
    var now = Date.now();
    var phase = currentPhase(now);
    if (phase !== state.phase) {
      var changed = state.phase !== null;
      state.phase = phase;
      applyPhase(phase);
      if (changed) document.dispatchEvent(new CustomEvent('sn-bfcm:phase', { detail: { phase: phase } }));
    }

    var countdowns = document.querySelectorAll('[data-sn-bfcm-countdown]');
    for (var i = 0; i < countdowns.length; i++) renderCountdown(countdowns[i], now);
  }

  C.api = {
    currentPhase: function () { return state.phase; },
    phaseEnd: phaseEnd,
    refresh: function () { state.phase = null; tick(); }
  };

  tick();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', C.api.refresh);
})();
